import { timedImport } from "./performance";

export const loadHome = () => timedImport("home", () => import("./screens/Home"));
export const loadGamePulse = () =>
  timedImport("overview", () => import("./screens/GamePulse"));
export const loadGameSessions = () =>
  timedImport("sessions", () => import("./screens/GameSessions"));
export const loadGameRetention = () =>
  timedImport("retention", () => import("./screens/GameRetention"));
export const loadGameFunnels = () =>
  timedImport("funnels", () => import("./screens/GameFunnels"));
export const loadGameAudience = () =>
  timedImport("audience", () => import("./screens/GameAudience"));
export const loadGameDiscovery = () =>
  timedImport("discovery", () => import("./screens/GameDiscovery"));
export const loadGameEconomy = () =>
  timedImport("economy", () => import("./screens/GameEconomy"));
export const loadGameProduct = () =>
  timedImport("product", () => import("./screens/GameProduct"));
export const loadGameProductDashboards = () => timedImport("product-dashboards", () => import("./screens/GameProductDashboards"));
export const loadGameNotifications = () => timedImport("notifications", () => import("./screens/GameNotifications"));
export const loadGamePerformance = () =>
  timedImport("performance", () => import("./screens/GamePerformance"));
export const loadGameParity = () =>
  timedImport("parity", () => import("./screens/GameParity"));
export const loadGameDataHealth = () =>
  timedImport("data-health", () => import("./screens/GameDataHealth"));
export const loadGameExperiments = () =>
  timedImport("experiments", () => import("./screens/GameExperiments"));

export function gameRouteLoader(path: string) {
  if (path.endsWith("/notifications")) return loadGameNotifications;
  if (path.endsWith("/dashboards")) return loadGameProductDashboards;
  if (path.endsWith("/sessions")) return loadGameSessions;
  if (path.endsWith("/retention")) return loadGameRetention;
  if (path.endsWith("/funnels")) return loadGameFunnels;
  if (path.endsWith("/audience")) return loadGameAudience;
  if (path.endsWith("/discovery") || path.endsWith("/thumbnails"))
    return loadGameDiscovery;
  if (path.endsWith("/economy") || path.endsWith("/currency")) return loadGameEconomy;
  if (
    path.endsWith("/product") ||
    path.endsWith("/shop") ||
    path.endsWith("/catalogue") ||
    path.endsWith("/gameplay")
  )
    return loadGameProduct;
  if (path.endsWith("/performance")) return loadGamePerformance;
  if (path.endsWith("/parity")) return loadGameParity;
  if (path.endsWith("/data-health")) return loadGameDataHealth;
  if (path.endsWith("/experiments")) return loadGameExperiments;
  return loadGamePulse;
}

/** Preload code on intent, never data queries. Respect constrained connections. */
export function prefetchGameRoute(path: string): void {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  if (connection?.saveData || connection?.effectiveType?.includes("2g")) return;
  void gameRouteLoader(path)().catch(() => undefined);
}
